import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/messaging";
import "firebase/analytics";

firebase.initializeApp({
  apiKey: process.env.REACT_APP_FAB_APIKEY,
  authDomain: process.env.REACT_APP_FAB_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_FAB_DATABASEURL,
  projectId: process.env.REACT_APP_FAB_PROJECTID,
  storageBucket: process.env.REACT_APP_FAB_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FAB_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FAB_APPID,
  measurementId: process.env.REACT_APP_FAB_MEASUREMENTID,
});

if ("indexedDB" in window) {
  firebase.analytics();
}

export const auth = firebase.auth();
export const database = firebase.database();
let message = null;

if ("Notification" in window) {
  message = firebase.messaging();

  message.onMessage((payload) => {
    console.log("Message received. ", payload);
    // ...
  });
}

export const messaging = message;
